import { useState } from "react";
import { Button, CircularProgress, Fab, FormControlLabel, Grid, IconButton, Switch, TextField, Typography } from "@mui/material";
import { Add as AddIcon, AddPhotoAlternate as AddPhotoAlternateIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog";
import { IconsLibrary } from "./modules/IconsLibrary";
import { useEffect } from "react";
import IconComponent from "./modules/IconComponent";
import { ChromePicker } from "react-color";
import { useMutation } from "react-query";
import { updateColumns } from "../services/api";

export default function Columns({ open, close, menu, category, instance, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [openIconsLibrary, setOpenIconsLibrary] = useState(false)
  const [indexToEditIcon, setIndexToEditIcon] = useState(null)
  const [disableSaveButton, setDisableSaveButton] = useState(true)
  const [color, setColor] = useState("#000000")
  const [columns, setColumns] = useState([{ name: "", icon: "", showName: false, showIcon: true }])

  useEffect(() => {
    if (instance !== null && instance !== undefined) {
      if (instance.columns !== undefined && instance.columns !== null) {
        setColumns(instance.columns)
        setColor(instance.columnsIconColor)
      }
    }
  }, [open])

  useEffect(() => {
    handleCheckIfActiveSaveButton()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns])

  const handleClose = () => { setColumns([{ name: "", icon: "", showName: false, showIcon: true }]); setColor("#000000"); close() }

  const mutation = useMutation(updateColumns, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleUpdate = () => {
    setIsLoading(true)
    mutation.mutate({ id: instance._id, params: { columns, color } })
  }

  const handleAddColumn = () => {
    setColumns([...columns, { name: "", icon: "", showName: false, showIcon: true }])
    //window.scrollTo(0, document.body.scrollHeight)
    const div = document.getElementById("mui-dialog-content");
    div.scrollTo({
      top: div.scrollHeight + 500,
      behavior: 'smooth'
    });
  }

  const handleDeleteColumn = (index) => setColumns(columns.filter((_, i) => i !== index))

  const handleEditData = (index, field, value) => {
    setColumns(columns.map((c, i) => i === index ? { ...c, [field]: value } : c))
  }

  const handleEditChangeBooleanData = (index, field) => {
    setColumns(columns.map((c, i) => i === index ? { ...c, [field]: !c[field] } : c))
  }

  const handleReturnIconSelected = (icon) => {
    setColumns(columns.map((c, i) => i === indexToEditIcon ? { ...c, icon } : c))
    setOpenIconsLibrary(false)
  }

  const handleCheckIfActiveSaveButton = () => {
    if (columns.length > 0) {
      let disable = false
      columns.forEach(column => {
        if (column.name === "" || column.icon === "") disable = true
      })
      setDisableSaveButton(disable)
    }
  }

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t('button_text_cancel')}</Button>
      <Button variant="contained" color="info" disabled={disableSaveButton} onClick={handleUpdate}>{t('button_text_edit')}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    <FlexibleWidthDialog maxWidth="md" open={open} title={t('builder_subcategories_dialog_title_columns')} actions={<Actions />}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} style={{ marginBottom: 20 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginBottom: 2 }}>{t('builder_subcategories_dialog_columns_iconcolor')}</Typography>
          <ChromePicker
            color={color}
            onChangeComplete={(color) => setColor(color.hex)}
            triangle="hide"
            colors={[]}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item xs={columns.length < 4 ? 10 : 12}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginBottom: 2 }}>{t('builder_subcategories_dialog_columns_iconlist')}</Typography>
                </Grid>
                {columns.length < 4 ?
                  <Grid item xs={2} style={{ display: "flex", justifyContent: "end" }}>
                    <Fab color="primary" aria-label="add" size="small" onClick={handleAddColumn}> <AddIcon /> </Fab>
                  </Grid>
                  : null}
              </Grid>
            </Grid>
            {columns.length > 0 ? <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2} sx={{ fontWeight: 500 }}>
                  <Grid item xs={3}> {t('builder_subcategories_dialog_columns_icon')} </Grid>
                  <Grid item xs={7}> {t('builder_subcategories_dialog_columns_name')} </Grid>
                  <Grid item xs={2}> </Grid>
                </Grid>
              </Grid>
              {columns.map((column, index) => (
                <Grid item xs={12} key={index}>
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      {column.icon !== undefined && column.icon !== "" && column.icon !== null ?
                        <IconButton onClick={() => { setIndexToEditIcon(index); setOpenIconsLibrary(true) }}>
                          <IconComponent name={`icon${column.icon}`} color={color} size={25} />
                        </IconButton>
                        :
                        <IconButton onClick={() => { setIndexToEditIcon(index); setOpenIconsLibrary(true) }}> <AddPhotoAlternateIcon /> </IconButton>
                      }
                      <FormControlLabel control={
                        <Switch edge="end" inputProps={{ 'aria-labelledby': `switch-list-label-${index}` }}
                          onClick={() => handleEditChangeBooleanData(index, "showIcon")}
                          checked={column.showIcon} />
                      } label={t('builder_subcategories_dialog_columns_show')} />
                    </Grid>
                    <Grid item xs={7}>
                      <TextField id="outlined-basic" variant="outlined" size="small" fullWidth value={column.name} onChange={(e) => handleEditData(index, "name", e.target.value)} />
                      <FormControlLabel control={
                        <Switch edge="end" inputProps={{ 'aria-labelledby': `switch-list-label-${index}` }}
                          onClick={() => handleEditChangeBooleanData(index, "showName")}
                          checked={column.showName} />
                      } label={t('builder_subcategories_dialog_columns_show')} />
                    </Grid>
                    <Grid item xs={2} style={{ display: "flex", justifyContent: "end" }}>
                      {index !== 0 ?
                        <IconButton onClick={() => handleDeleteColumn(index)}> <DeleteIcon /> </IconButton>
                        : null}
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid> : null}
          </Grid>
          {disableSaveButton ?
            <Grid item xs={12} style={{ marginTop: 20 }}>
              <Typography variant="subtitle1" sx={{ color: "#D0021B" }}>{t('builder_subcategories_dialog_columns_instructions')}</Typography>
            </Grid> : null}
        </Grid>
      </Grid>
    </FlexibleWidthDialog>
    <IconsLibrary
      open={openIconsLibrary}
      close={() => setOpenIconsLibrary(false)}
      color={color}
      returnIconSelected={handleReturnIconSelected} />
  </>)
}